import datapoints from '../datapoints';
import { makePostRequest } from 'owa-ows-gateway';
import { getGuid } from 'owa-guid';
import { PerformanceDatapoint } from 'owa-analytics';
import {
    getDefaultOptions,
    OwsOptionsFeatureType,
    lazyCreateOrUpdateOptionsForFeature,
} from 'owa-outlook-service-options';

const endpoint: string = 'ows/api/beta/Addins/PinAddins';
const perfDatapoint = datapoints.PinRequest.datapoint;

/**
 * This should only be called during the opt-in FRE and happen before OWA is visible to the user
 */
export default function makePinRequest(): void {
    const correlationId = getGuid();
    const datapoint = new PerformanceDatapoint(perfDatapoint.name);
    makePostRequest(
        endpoint,
        { correlationId, defaults: getDefaultOptions()[OwsOptionsFeatureType.SurfaceActions] },
        correlationId,
        true /* returnFullResponse */
    )
        .then((response: Response) => {
            datapoint.addCustomData(perfDatapoint.customData(correlationId, response.status));
            if (response.status == 200) {
                response.text().then(body => {
                    lazyCreateOrUpdateOptionsForFeature.importAndExecute(
                        OwsOptionsFeatureType.SurfaceActions,
                        JSON.parse(body)
                    );
                });
            }
            datapoint.end();
        })
        .catch(() => {
            // Make*Request has no thowing path, but just in case
            datapoint.end();
        });
}
